import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { userApi } from '../api/user';
import { useUser } from './useUser';

const useTrackRouteChanges = () => {
  const location = useLocation(); // Tracks the current path
  const user = useUser();
  // 親オリジンは iframe のクエリから取得し、なければ sessionStorage から復元する
  // 理由: SPA 内の遷移でクエリが失われると postMessage の targetOrigin が空になってしまうため
  const params = new URLSearchParams(typeof(window) !== 'undefined' ? window.location.search : '');
  const rawParentOrigin = params.get('parentOrigin');
  const parentOriginFromQuery = rawParentOrigin ? decodeURIComponent(rawParentOrigin) : '';
  if (parentOriginFromQuery && typeof(window) !== 'undefined') {
    try {
      // 理由:
      // - sessionStorage は「同一タブ限定」で、タブを閉じれば自動的に消えるため手動クリアは不要。
      // - 親アプリから埋め込み直されるたびに parentOrigin クエリが渡され、常に最新値で上書きされる。
      //   したがって古い値が残り続けることによる誤動作は起きない。
      sessionStorage.setItem('cards_parent_origin', parentOriginFromQuery);
    } catch { /* ignore */ }
  }
  const allowedOrigin = parentOriginFromQuery
    || (typeof(window) !== 'undefined' ? (sessionStorage.getItem('cards_parent_origin') || '') : '');
  const postMessageTarget = '*'; // 常にワイルドカード指定（社内システム向けに制限なし）

  useEffect(() => {
    const path = location.pathname;

    // 1) 親アプリに現在の名刺SPAのルート/戻れるかどうかを通知
    try {
      const canGoBack = path !== '/'; // 名刺機能トップなら戻れない。それ以外は戻れる。
      const message = { type: 'CARDS_ROUTE', path, canGoBack } as const;
      // 親アプリ（iframeの親ウィンドウ）へ通知
      if (window.parent && window.parent !== window) {
        // 親のオリジンをワイルドカード指定（内部システムのためセキュリティ制限なし）
        window.parent.postMessage(message, postMessageTarget);
      }
    } catch (_) {
      // 送信失敗は無視（親がいない場合など）
    }

    // 既存のルート監視（必要に応じてログなど）
    if (path.startsWith('/camera')) {
      const parts = path.split('/'); // Split path into segments
      if (parts.length > 2 && parts[2]) {
        const parsed = parseInt(parts[2], 10); // Attempt to parse the cardKey
        if (!isNaN(parsed) && parsed > 0) {
          //const cardKey = parsed; // Set cardKey if parsing succeeds
          //userApi.logUserEvent('view', cardKey);
        } else {
          //console.log(`Navigated to Camera. Card Key malformed`);
        }
      } else {
        //console.log(`Navigated to Camera. No Card Key`);
      }
    } else {
      // console.log(`Navigated to ${path}`);
    }
  }, [location]); // Trigger effect when location changes

  useEffect(() => {
    // 2) 親アプリからの戻る指示を受け取り、名刺SPA内で1段階戻る
    const handleMessage = (event: MessageEvent<{ type?: string }>) => {
      const data = event.data;
      if (!data || typeof(data) !== 'object' || !('type' in data)) return;
      // オリジン制限は行わない（社内システム向けポリシー）
      if (data.type === 'PARENT_BACK') {
        // カメラ配下（/camera）は CardInput 側で二段階戻し（閲覧→スキャン→履歴戻り）を制御する
        if (location.pathname.startsWith('/camera')) {
          return;
        }
        // それ以外は従来どおりブラウザ履歴を1つ戻す
        window.history.back();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [allowedOrigin, location.pathname]);
};

export default useTrackRouteChanges;